import script from "./NewReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./NewReminder.vue?vue&type=script&setup=true&lang=js"

import "./NewReminder.vue?vue&type=style&index=0&id=22fb6498&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fb6498"]])

export default __exports__